import axios from 'axios';

const webObj = axios.create({
    baseURL: process.env.VUE_APP_MIX_URL,
})

export const apiInfo = (sn) => webObj.get(`/api/records/project/${sn}`)
export const apiAll = (sn) => webObj.get(`/api/records/all`)